module.exports = __webpack_public_path__ + "static/img/laylar.661c1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laylar.png
// module id = zF+K
// module chunks = 1